module.exports = __webpack_public_path__ + "img/bg-right.d5fa40ed.png";